
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 23.6 32.4"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.8 30.6l2.6-13.1c0-1 .8-1.8 1.7-1.8 0 0 0 0 0 0h11.4c1 0 1.7-.8 1.8-1.8l2.6-12.3","opacity":".64","fill":"none","stroke":"#fff","stroke-width":"3.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    